/*
 * @Description: 微扬官网中文语言包
 * @Author: pliybird
 * @Date: 2023-05-26 15:44:31
 * @LastEditTime: 2025-10-15 18:23:34
 * @LastEditors: pliybird
 * @filePath: Do not edit
 */
const home = require("./home.json");
const solution = require("./solution.json");
const solution_crm = require("./solution_crm.json");
const product = require("./product.json");
const service = require("./service.json");
const cases = require("./cases.json");
const news = require("./news.json");
const overseas = require("./overseas.json");
const about_us = require("./about_us.json");
const single_home = require("./single_home.json");

export default {
  language: "日本語",
  feedback: {
    scrollTop: {
      tab01: "微信扫码，在线咨询",
      tab02: "联系我们",
      tab03_1: "业务咨询",
      tab03_2: "提交信息后我们将第一时间联系您",
    },
    form: {
      title: "业务咨询",
      form_fullname: "姓名（必填）",
      form_telephone: "联系电话（必填）",
      form_emailAddress: "电子邮箱",
      form_tip1: "输入的电子邮箱格式不正确",
      form_captcha: "图形验证码（必填）",
      form_tip2: "请输入正确的验证码",
      form_companyName: "公司全称（必填）",
      form_companyLocation: "公司所在地",
      form_customerIndustry: "所属行业",
      form_customerBudget: "预算需求",
      form_consultDetails: "业务咨询（必填）",
      form_choose: "请选择",
      form_btn: "提交",
      form_success: "信息提交成功",
    },
  },
  footer: {
    contact: "プリセールスサービスセンター",
    fllow: "フォロー",
    wechat_account: "HAND Vyung",
    wechat_channel: "HAND Vyung Official WeChat Channel",
    about_vyung: "HAND Vyungについて",
    company_info: "企業情報",
    offices: "オフィス",
    news: "ニュース",
    links: "リンクス",
    hand: "Hand",
    hellos: "HELIOS",
    dingyi: "Dingyi",
    more: "その他のオススメ",
    cases: "顧客事例",
    copyright: "Shanghai Hand Vyung Information Technology Co.,LTD",
    hand_us: "HAND US",
    hand_jp: "HAND Japan",
    hand_eu: "HAND Europe",
    hand_sg: "HAND Singapore",
  },
  home: home,
  solution: solution,
  solution_crm: solution_crm,
  product: product,
  service: service,
  cases: cases,
  news: news,
  overseas: overseas,
  about_us: about_us,
  single_home,
};
